export default "__VITE_ASSET__COX2hxjp__"